import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import { useSearchParams } from "react-router-dom";
import { forceManyBody } from 'd3';
import { saveAs } from "file-saver";


const backendUrl = process.env.REACT_APP_BACKEND_URL;
const webzashUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
const API_URL = `${backendUrl}/api/categories`;
const webzashAPI = `${webzashUrl}/api/groups/index`;

const CategoryDetails = () => {
    const [categories, setCategories] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [errors, setErrors] = useState({});
    const WithCreatePermission = withPermission(({ children }) => children, ['category-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['category-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['category-delete']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type") || "product";
    const [webzashGroups, setWebzashGroups] = useState([]);
    const [selectedWebzashGroup, setSelectedWebzashGroup] = useState('');

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchCategories(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [type, searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchCategories = async (page = 1, search = '') => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params: {
                    page,
                    search: searchQuery,
                    type,
                },
            });
            setCategories(response.data.category?.data || response.data.category || []);
            setPageCount(response.data.category?.last_page || 1);
            setCurrentPage(response.data.category?.current_page || 1);


        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };
    const [allWebzashGroups, setAllWebzashGroups] = useState([]);
    const [expenseGroups, setExpenseGroups] = useState([]); // children under Expenses
    const [assetGroups, setAssetGroups] = useState([]);

    // const fetchExpenseGroups = async () => {
    //     try {
    //         const response = await axios.get(`${webzashAPI}`, {
    //             headers: {
    //                 'x-api-key': process.env.REACT_APP_API_KEY,
    //                 'Accept': 'application/json'
    //             },
    //             skipLoader: true,

    //         });

    //         const allGroups = response.data || [];

    //         const expensesGroup = allGroups.find(g => g.Group.name === 'Expenses');

    //         const expenseChildren = allGroups.filter(
    //             g => g.Group.parent_id === expensesGroup?.Group.id
    //         );

    //         setWebzashGroups(expenseChildren);
    //         setAllWebzashGroups(allGroups);

    //     } catch (error) {
    //         console.error("Error fetching expense groups:", error);
    //     }
    // };


    //     const fetchExpenseGroups = async () => {
    //     try {
    //         const response = await axios.get(`${webzashAPI}`, {
    //             headers: {
    //                 'x-api-key': process.env.REACT_APP_API_KEY,
    //                 'Accept': 'application/json'
    //             },
    //             skipLoader: true,
    //         });

    //         const allGroups = response.data || [];
    //         setAllWebzashGroups(allGroups);

    //     } catch (error) {
    //         console.error("Error fetching Webzash groups:", error);
    //     }
    // };


    // useEffect(() => {

    //     if (type === 'expense' && showModal) {
    //         fetchExpenseGroups();
    //     }
    // }, [type, showModal]);
    const fetchExpenseGroups = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/groups`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Accept': 'application/json'
                },
                skipLoader: true,
            });

            const rawGroups = response.data.data || [];
            // Map to old Webzash format { Group: { ... } } to avoid breaking component state structure
            const allGroups = rawGroups.map(g => ({ Group: g }));
            
            setAllWebzashGroups(allGroups);

            const expensesGroup = allGroups.find(g => g.Group.name?.toLowerCase() === 'expenses' || g.Group.name === 'Expenses');
            const assetsGroup = allGroups.find(g => g.Group.name?.toLowerCase() === 'assets' || g.Group.name === 'Assets');

            const expenseChildren = allGroups.filter(g => String(g.Group.parent_id) === String(expensesGroup?.Group?.id));
            const assetChildren = allGroups.filter(g => String(g.Group.parent_id) === String(assetsGroup?.Group?.id));

            setExpenseGroups(expenseChildren);
            setAssetGroups(assetChildren);
        } catch (error) {
            console.error("Error fetching groups from backend:", error);
        }
    };


    useEffect(() => {
        // Load Webzash groups when modal opens for expense type
        if (type === 'expense' && showModal) {
            fetchExpenseGroups();
        }
    }, [type, showModal]); // This will load groups when the modal opens for 'expense' type
    // Removed showModal useEffect that cleared selectedWebzashGroup on every modal open



    const handleAddCategory = () => {
        setFormData({ name: '', parent_id: '', is_petty_cash: false, group_id: '' });
        setIsEdit(false);
        setSelectedCategory(null);
        setSelectedWebzashGroup(""); // Reset dropdown
        setShowModal(true);
        setErrors({});

    };

    const handleEditCategory = (category) => {
        const parentGroupId = category.group?.parent_id || category.group_id ||category.group?.group_id ||'';
        
        setFormData({
            ...category,
            asSubCategory: category.parent_id ? true : false,  // Check if category has parent_id
            is_petty_cash: category.is_petty_cash || false,
            group_id: parentGroupId, // Ensure group_id is set to parent's ID
            status: category.status ? 'active' : 'inactive',  // Map boolean status to string
        });
        setIsEdit(true);
        setSelectedCategory(category);
        setSelectedWebzashGroup(parentGroupId); // Pre-select in dropdown
        setShowModal(true);
        setErrors({});

    };
    const showErrorToast = (title) => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title,
            showConfirmButton: false,
            timer: 3500,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    };
    const extractApiErrorMessage = (error, fallback = 'Something went wrong') => {
        if (error?.response?.data) {
            const data = error.response.data;

            // Laravel / API validation errors
            if (data.validationErrors) {
                return Object.values(data.validationErrors)
                    .flat()
                    .join(', ');
            }

            // Generic error message
            if (data.error) {
                return data.error;
            }

            if (data.message) {
                return data.message;
            }
        }

        return fallback;
    };

    const createWebzashGroup = async (name, parentId) => {
        const groupPayload = {
            Group: {
                name,
                parent_id: parentId,
                code: null,
                affects_gross: 1,
            }
        };

        try {
            const response = await axios.post(`${webzashUrl}/api/groups/add`, groupPayload, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json'
                }
            });
            return response.data;

        } catch (error) {
            console.error("Failed to create Webzash group:", error);
            const message = extractApiErrorMessage(
                error,
                'Failed to create Webzash group'
            );

            showErrorToast(message);

            // IMPORTANT: return null so caller knows it failed
            return null;
        }
    };

    const updateWebzashGroup = async (groupId, newName, parentId) => {
        const updatePayload = {
            Group: {
                name: newName,
                parent_id: parentId,
                code: null,
                affects_gross: 1,

            }
        };

        try {
            await axios.put(`${webzashUrl}/api/groups/edit/${groupId}`, updatePayload, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json'
                }
            });
            console.log("Webzash group updated");
        } catch (error) {
            console.error("Failed to update Webzash group:", error);
             const message = extractApiErrorMessage(
        error,
        'Failed to update Webzash group'
    );

    showErrorToast(message);
        }
    };

    const deleteWebzashGroup = async (groupId) => {
        try {
            // Fetch all groups to check for children
            const response = await axios.get(`${webzashUrl}/api/groups/index`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json'
                }
            });

            const allGroups = response.data;
            const hasChildren = allGroups.some(g => g.Group.parent_id === groupId);

            if (hasChildren) {
                console.warn("Group has child groups. Cannot delete.");
                Swal.fire(
                    "Delete Blocked",
                    "This group has subgroups. Please delete or move them first.",
                    "warning"
                );
                return;
            }

            await axios.delete(`${webzashUrl}/api/groups/delete/${groupId}`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json'
                }
            });

            console.log("Webzash group deleted");
            Swal.fire("Deleted!", "Group deleted successfully.", "success");
        } catch (error) {
            console.error("Failed to delete Webzash group:", error);
            Swal.fire("Error!", "Failed to delete group.", "error");
        }
    };



    // const handleDelete = async (id) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#3085d6",
    //         confirmButtonText: "Yes, delete it!"
    //     }).then(async (result) => {
    //         if (result.isConfirmed) {
    //             try {
    //                 const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //                 const origin = localStorage.getItem('user-origin');
    //                 const token = userInfo?.token;
    //                 await axios.delete(`${API_URL}/${id}`, {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                         'Tenant-Origin': origin,

    //                     },
    //                 });
    //                 setCategories(categories.filter(category => category.id !== id));
    //                 if (type === 'expense') {
    //                     const deletedCategory = categories.find(cat => cat.id === id);
    //                     console.log("Deleted Category:", deletedCategory);

    //                     const categoryName = deletedCategory?.name?.trim().toLowerCase();
    //                     const categoryParentId = String(deletedCategory?.group_id ?? '');

    //                     console.log("Searching for group with name:", categoryName);
    //                     console.log("And parent_id:", categoryParentId);
    //                     console.log("All Webzash Groups:", allWebzashGroups);

    //                     const groupToDelete = allWebzashGroups.find(g => {
    //                         const groupName = g.Group?.name?.trim().toLowerCase();
    //                         const groupParentId = String(g.Group?.parent_id ?? '');

    //                         console.log("Comparing group:", groupName, "==", categoryName);
    //                         console.log("Comparing parent:", groupParentId, "==", categoryParentId);

    //                         return groupName === categoryName && groupParentId === categoryParentId;
    //                     });



    //                     console.log("Group to delete:", groupToDelete);

    //                     if (groupToDelete) {
    //                         await deleteWebzashGroup(groupToDelete.Group.id);
    //                     } else {
    //                         console.warn("❌ No matching Webzash group found. Skipping delete.");
    //                     }




    //                 }


    //                 Swal.fire(
    //                     "Deleted!",
    //                     "The category has been deleted.",
    //                     "success"
    //                 );
    //             } catch (error) {
    //                 console.error('Error deleting category:', error);
    //                 Swal.fire(
    //                     "Error!",
    //                     "Failed to delete category. Please try again.",
    //                     "error"
    //                 );
    //             }
    //         }
    //     });

    // };

    // const handleDelete = async (id) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#3085d6",
    //         confirmButtonText: "Yes, delete it!"
    //     }).then(async (result) => {
    //         if (result.isConfirmed) {
    //             try {
    //                 const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //                 const origin = localStorage.getItem('user-origin');
    //                 const token = userInfo?.token;

    //                 // Get the category before deletion
    //                 const deletedCategory = categories.find(cat => cat.id === id);

    //                 // Delete from your main system first
    //                 await axios.delete(`${API_URL}/${id}`, {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                         'Tenant-Origin': origin,
    //                     },
    //                 });

    //                 // Update local state
    //                 setCategories(categories.filter(category => category.id !== id));

    //                 // Handle Webzash deletion for expense categories
    //                 if (type === 'expense' && deletedCategory) {
    //                     console.log("Deleted Category:", deletedCategory);

    //                     const categoryName = deletedCategory?.name?.trim();
    //                     const categoryGroupId = deletedCategory?.group_id; // This is the PARENT group ID (14)

    //                     console.log("Searching for group with name:", categoryName);
    //                     console.log("And parent_id:", categoryGroupId);
    //                     console.log("All Webzash Groups:", allWebzashGroups);

    //                     // Find the matching Webzash group - Look in ALL groups for children
    //                     const groupToDelete = allWebzashGroups.find(g => {
    //                         const groupName = g.Group?.name?.trim();
    //                         const groupParentId = g.Group?.parent_id;

    //                         console.log("Comparing:", {
    //                             webzashName: groupName,
    //                             categoryName: categoryName,
    //                             webzashParentId: groupParentId,
    //                             categoryGroupId: categoryGroupId
    //                         });

    //                         // Match by name AND parent_id
    //                         return groupName === categoryName &&
    //                             groupParentId === categoryGroupId;
    //                     });

    //                     console.log("Group to delete:", groupToDelete);

    //                     if (groupToDelete) {
    //                         await deleteWebzashGroup(groupToDelete.Group.id);
    //                     } else {
    //                         console.warn("❌ No matching Webzash group found. Skipping delete.");
    //                         console.log("Available child groups:", allWebzashGroups
    //                             .filter(g => g.Group.parent_id === categoryGroupId)
    //                             .map(g => ({
    //                                 name: g.Group.name,
    //                                 id: g.Group.id,
    //                                 parent_id: g.Group.parent_id
    //                             }))
    //                         );
    //                     }
    //                 }

    //                 Swal.fire(
    //                     "Deleted!",
    //                     "The category has been deleted.",
    //                     "success"
    //                 );
    //             } catch (error) {
    //                 console.error('Error deleting category:', error);
    //                 Swal.fire(
    //                     "Error!",
    //                     "Failed to delete category. Please try again.",
    //                     "error"
    //                 );
    //             }
    //         }
    //     });
    // };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    // Get the category before deletion
                    const deletedCategory = categories.find(cat => cat.id === id);

                    // Delete from your main system first
                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    // Update local state
                    setCategories(categories.filter(category => category.id !== id));

                    // Handle Webzash deletion for expense categories
                    let deletedWebzashGroupId = null;
                    if (type === 'expense' && deletedCategory) {
                        console.log("Deleted Category:", deletedCategory);

                        const categoryName = deletedCategory?.name?.trim();
                        const categoryGroupId = deletedCategory?.group_id;

                        console.log("Searching for group with name:", categoryName);
                        console.log("And parent_id:", categoryGroupId);
                        console.log("All Webzash Groups:", allWebzashGroups);

                        // Find the matching Webzash group
                        const groupToDelete = allWebzashGroups.find(g => {
                            const groupName = g.Group?.name?.trim();
                            const groupParentId = g.Group?.parent_id;

                            return groupName === categoryName &&
                                groupParentId === categoryGroupId;
                        });

                        console.log("Group to delete:", groupToDelete);

                        if (groupToDelete) {
                            deletedWebzashGroupId = groupToDelete.Group.id;
                            await deleteWebzashGroup(groupToDelete.Group.id);

                            // ✅ IMPORTANT: Update allWebzashGroups state to remove the deleted group
                            setAllWebzashGroups(prev =>
                                prev.filter(g => g.Group.id !== deletedWebzashGroupId)
                            );

                            // Also update expenseGroups and assetGroups if needed
                            setExpenseGroups(prev =>
                                prev.filter(g => g.Group.id !== deletedWebzashGroupId)
                            );
                            setAssetGroups(prev =>
                                prev.filter(g => g.Group.id !== deletedWebzashGroupId)
                            );

                            console.log("✅ Updated allWebzashGroups after deletion");
                        } else {
                            console.warn("❌ No matching Webzash group found. Skipping delete.");
                        }
                    }

                    Swal.fire(
                        "Deleted!",
                        "The category has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting category:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete category. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        // Ensure that we handle the radio button correctly
        if (name === "status") {
            setFormData((prev) => ({
                ...prev,
                status: value,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value,
            }));
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };
    const getAccountStatusBadge = (status) => {
        if (status === true) {
            return <span className="badge badge-pill badge-soft-success font-size-12 text-success">Active</span>;
        } else if (status === false) {
            return <span className="badge badge-pill badge-soft-warning font-size-12 text-danger">Inactive</span>;
        }
        return <span className="badge badge-pill badge-soft-secondary font-size-12">Unknown</span>;
    };


    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchCategories(newPage);
    };
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';


        return newErrors;
    };
    const [loading, setLoading] = useState(false);

    const showSuccessToast = (title) => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: title,
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    };



    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        try {
            const payload = { ...formData, type, group_id: selectedWebzashGroup || formData.group_id || null };
            let response;

            console.log("🔄 Submitting form:", payload);

            if (isEdit) {
                console.log("✏️ Editing category with ID:", selectedCategory.id);

                response = await axios.put(`${API_URL}/${selectedCategory.id}`, payload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                console.log("✅ Category updated:", response.data.category);

                setCategories(categories.map(ind =>
                    ind.id === selectedCategory.id ? response.data.category : ind
                ));
                showSuccessToast('Category updated successfully ✅');

            } else {
                console.log("➕ Creating new category");

                response = await axios.post(API_URL, payload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                console.log("✅ Category created:", response.data.category);

                setCategories([...categories, response.data.category]);
                showSuccessToast('Category Added successfully ✅');

            }
            setShowModal(false);
        } catch (error) {
            console.error('❌ Unexpected error during submit:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredCategories = categories.filter(category => !category.parent_id);
    const handleTypeChange = (e) => {
        const newType = e.target.value;
        setFormData(prev => ({ ...prev, category_type: newType, group_id: "" }));
        setSelectedWebzashGroup("");
    };

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });

    const handleExport = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            // 👇 Include the category type dynamically (product / expense)
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/categories/export`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
                params: { type }, // <-- important
            });

            const fileName = type === "expense" ? "expense_categories.xlsx" : "product_categories.xlsx";
            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, fileName);

            Toast.fire({
                icon: "success",
                title: `Exported ${type} categories successfully!`,
            });
        } catch (error) {
            console.error("Export error:", error);
            Toast.fire({
                icon: "error",
                title: "Export failed! Please try again.",
            });
        }
    };

    const handleImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", type); // 👈 include type param here

        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/categories/import`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            Toast.fire({
                icon: "success",
                title: `Imported ${type} categories successfully!`,
            });
            setTimeout(() => window.location.reload(), 1000);

            e.target.value = "";
        } catch (error) {
            console.error("Import error:", error);

            let message = "Import failed! Please check your file.";

            if (error.response?.status === 422 && error.response?.data?.errors) {
                message = error.response.data.errors.join("\n");
            } else if (error.response?.data?.message) {
                message = error.response.data.message;
            }

            Toast.fire({
                icon: "warning",
                title: message,
            });
            e.target.value = "";
        }
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Category</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        {/* <li className="breadcrumb-item"><a href="javascript:void(0);">Category</a></li> */}
                                        {/* <li className="breadcrumb-item active">Category List</li> */}
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>

                                        {/* <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddCategory} data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add Category"
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button>
                                        </WithCreatePermission> */}
                                        <div className="d-flex align-items-center gap-2">
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export to Excel"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import from Excel"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>

                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                    onClick={() => handleAddCategory()}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add Category"
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle"> Name</th>
                                                    {/* {type === "expense" && <th className="align-middle">Petty Cash</th>} */}
                                                    <th className="align-middle"> Description</th>


                                                    {type !== "expense" && (
                                                        <>
                                                            <th className="align-middle"> Category</th>


                                                        </>
                                                    )}

                                                    <th className="align-middle">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(categories) && categories.length > 0 ? (
                                                    categories.map((category, index) => (
                                                        <tr key={category.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`instanceCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`instanceCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>
                                                            <td>{category.name}</td>
                                                            <td className="narration-cell" title={category.description || ""}>
                                                                {category.description || ""}</td>

                                                            {/* {type === "expense" && (
                                                                <td>
                                                                    {category.is_petty_cash ? (
                                                                        <span className="badge bg-success bg-soft text-success">Yes</span>
                                                                    ) : (
                                                                        <span className="badge bg-danger bg-soft text-danger">No</span>
                                                                    )}
                                                                </td>
                                                            )} */}

                                                            {type !== "expense" && (
                                                                <>
                                                                    <td>{category.licence_type}</td>
                                                                </>
                                                            )}
                                                            <td>
                                                                <div className="dropdown">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li><WithEditPermission>
                                                                            <button className="dropdown-item" onClick={() => handleEditCategory(category)}>
                                                                                Edit
                                                                            </button></WithEditPermission>
                                                                        </li>
                                                                        <li><WithDeletePermission>
                                                                            <button className="dropdown-item" onClick={() => handleDelete(category.id)}>
                                                                                Delete
                                                                            </button></WithDeletePermission>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">
                                                            No categories found.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit Category */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' style={{ width: '450px' }}>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>
                                                {type === "product"
                                                    ? (isEdit ? 'Edit Type' : 'Add Type')
                                                    : (isEdit ? 'Edit Category' : 'Add Category')}
                                            </Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                {type === "expense" && (
                                                    <>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="form-font">Type</Form.Label>
                                                            <Form.Select name="category_type" value={formData.category_type} onChange={handleTypeChange}>
                                                                <option value="">Select Type</option>
                                                                <option value="expense">Expense</option>
                                                                <option value="asset">Asset</option>
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group controlId="webzashGroup" className="mb-3">
                                                            <Form.Label className='form-label form-font'>{formData.category_type === 'expense' ? 'Expense Group' : 'Asset Group'}</Form.Label>
                                                            <Form.Select
                                                                name="group_id"
                                                                value={selectedWebzashGroup || formData.group_id || ''}
                                                                onChange={(e) => setSelectedWebzashGroup(e.target.value)}
                                                                className="form-control form-feild"
                                                            >
                                                                <option value="">Select Group</option>
                                                                {(formData.category_type === 'expense' ? expenseGroups : assetGroups).map(({ Group }) => (
                                                                    <option key={Group.id} value={Group.id}>{Group.name}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                        {/* <Form.Group controlId="webzashGroup">
                                                        <Form.Label className='form-label form-font'>Expense Group</Form.Label>
                                                        <Form.Select
                                                            name="group_id"
                                                            value={selectedWebzashGroup || formData.group_id || ''}
                                                            onChange={(e) => setSelectedWebzashGroup(e.target.value)}
                                                            className="form-control form-feild"
                                                        >
                                                            <option value="">Select Group</option>
                                                            {webzashGroups.map(({ Group }) => (
                                                                <option key={Group.id} value={Group.id}>
                                                                    {Group.name}
                                                                </option>
                                                            ))}
                                                        </Form.Select>

                                                    </Form.Group> */}
                                                    </>
                                                )}<br />

                                                <Form.Group controlId="categoryName">
                                                    <Form.Label className='form-label form-font'>Name</Form.Label>
                                                    <Form.Control type="text" name="name" style={{ fontSize: '13px' }} value={formData.name} onChange={handleInputChange}
                                                        className={`form-feild form-control ${errors?.name ? 'is-invalid' : ''}`}

                                                    />
                                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}

                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>Description</Form.Label>
                                                    <Form.Control style={{ fontSize: '13px' }}
                                                        as="textarea"
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                                {/* {type === "expense" && (
                                                    <Form.Group controlId="isPettyCash" className="mb-3">
                                                        <Form.Check
                                                            style={{ fontSize: '13px' }}
                                                            type="checkbox"
                                                            name="is_petty_cash"
                                                            label="Mark as Petty Cash"
                                                            checked={formData.is_petty_cash}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Form.Group>
                                                )} */}

                                                {type === "product" && (
                                                    <>
                                                        {/* <Form.Group className="mb-3">
                                                            <Form.Label style={{ fontSize: '13px' }}>Code</Form.Label>
                                                            <Form.Control style={{ fontSize: '13px' }}
                                                                type="text"
                                                                name="code"
                                                                value={formData.code}
                                                                onChange={handleInputChange}
                                                            />
                                                        </Form.Group> */}
                                                        <Form.Group className="mb-3">
                                                            <Form.Label style={{ fontSize: '13px' }}>Code</Form.Label>
                                                            <Form.Select
                                                                name="licence_type"
                                                                value={formData.licence_type || ''}
                                                                onChange={handleInputChange}
                                                                className="form-control form-feild"
                                                            >

                                                                <option value="">Select Type</option>
                                                                <option value='service'>Service</option>
                                                                <option value='license'>License</option>

                                                            </Form.Select>
                                                        </Form.Group>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label style={{ fontSize: '13px' }}>Description</Form.Label>
                                                            <Form.Control style={{ fontSize: '13px' }}
                                                                as="textarea"
                                                                name="description"
                                                                value={formData.description}
                                                                onChange={handleInputChange}
                                                            />
                                                        </Form.Group>
                                                        {/* <Form.Group controlId="categoryStatus" className="mb-3">
                                                            <div>
                                                                <label style={{ fontSize: '13px' }}>
                                                                    <input style={{ width: '15px', height: '15px' }}
                                                                        type="radio"
                                                                        name="status"
                                                                        value="active"
                                                                        checked={formData.status === 'active'}
                                                                        onChange={handleInputChange}
                                                                    />&nbsp;
                                                                    Active
                                                                </label>
                                                                <label style={{ fontSize: '13px' }}>&nbsp;&nbsp;
                                                                    <input style={{ width: '15px', height: '15px' }}
                                                                        type="radio"
                                                                        name="status"
                                                                        value="inactive"
                                                                        checked={formData.status === 'inactive'}
                                                                        onChange={handleInputChange}
                                                                    />&nbsp;
                                                                    Inactive

                                                                </label>
                                                            </div>
                                                        </Form.Group><br />



                                                        <Form.Check style={{ fontSize: '13px' }}
                                                            className="mb-3"
                                                            type="checkbox"
                                                            label="Add as Subcategory"
                                                            name="asSubCategory"
                                                            checked={formData.asSubCategory}
                                                            onChange={handleInputChange}
                                                        />

                                                        {formData.asSubCategory && (

                                                            <Form.Group controlId="categoryParent" className="mb-3">
                                                                <Form.Label style={{ fontSize: '13px' }}>Parent Category</Form.Label>
                                                                <Form.Control style={{ fontSize: '13px' }}
                                                                    as="select"
                                                                    name="parent_id"
                                                                    value={formData.parent_id}
                                                                    onChange={handleInputChange}
                                                                >
                                                                    <option value="" >Select Parent Category</option>
                                                                    {filteredCategories.map(category => (
                                                                        <option key={category.id} value={category.id}>
                                                                            {category.name}
                                                                        </option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        )} */}
                                                    </>
                                                )}
                                                {/* <Form.Check
                                                    type="checkbox"
                                                    label="Active"
                                                    name="status"
                                                    checked={formData.status}
                                                    onChange={handleInputChange}
                                                /> */}
                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="secondary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryDetails;

